import { useFeatureFlagEnabled } from '@posthog/react';

/** Internal-only gate for bulk photo import in the Field Notes tab (drop a zip of photos -> field notes). */
export const BULK_PHOTO_IMPORT_FLAG = 'bulk-photo-import-enabled';

export function useBulkPhotoImportEnabled(): boolean {
  return useFeatureFlagEnabled(BULK_PHOTO_IMPORT_FLAG) === true;
}
